import React from 'react'
import {NotificationData} from "../../../types/NotificationData";
import NotificationEntry from "../NotificationEntry/NotificationEntry";

const NotificationList: React.FC<{ notifications: NotificationData[] | null }> = ({ notifications }) => {

    return (
        <div>
            {notifications && notifications.map((notification) => (
                <NotificationEntry key={notification.title} notification={notification} />
            ))}
        </div>)
}

export default NotificationList
